module.exports = __webpack_public_path__ + "static/media/big-logo.fb3a0b34.png";